/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PostApiV1ExamExamidLangsMutationRequest,
  PostApiV1ExamExamidLangsMutationResponse,
  PostApiV1ExamExamidLangsPathParams,
  PostApiV1ExamExamidLangs401,
  PostApiV1ExamExamidLangs404,
  PostApiV1ExamExamidLangs500,
} from "../../types/examEvaluationController/PostApiV1ExamExamidLangs.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { postApiV1ExamExamidLangs } from "../../clients/examEvaluationController/postApiV1ExamExamidLangs.ts";

export const postApiV1ExamExamidLangsMutationKey = () =>
  [{ url: "/api/v1/exam/:examId/langs" }] as const;

export type PostApiV1ExamExamidLangsMutationKey = ReturnType<
  typeof postApiV1ExamExamidLangsMutationKey
>;

export function postApiV1ExamExamidLangsMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<PostApiV1ExamExamidLangsMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const mutationKey = postApiV1ExamExamidLangsMutationKey();
  return mutationOptions<
    PostApiV1ExamExamidLangsMutationResponse,
    ResponseErrorConfig<
      | PostApiV1ExamExamidLangs401
      | PostApiV1ExamExamidLangs404
      | PostApiV1ExamExamidLangs500
    >,
    {
      examId: PostApiV1ExamExamidLangsPathParams["examId"];
      data?: PostApiV1ExamExamidLangsMutationRequest;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ examId, data }) => {
      return postApiV1ExamExamidLangs(examId, data, config);
    },
  });
}

/**
 * @description Cria um novo idioma para a prova informada. O idioma (CultureInfo) deve ser único por prova. **(Requer Authorization para autenticação)**
 * @summary Criar idioma de prova (Requer Authorization para autenticação)
 * {@link /api/v1/exam/:examId/langs}
 */
export function usePostApiV1ExamExamidLangs<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiV1ExamExamidLangsMutationResponse,
      ResponseErrorConfig<
        | PostApiV1ExamExamidLangs401
        | PostApiV1ExamExamidLangs404
        | PostApiV1ExamExamidLangs500
      >,
      {
        examId: PostApiV1ExamExamidLangsPathParams["examId"];
        data?: PostApiV1ExamExamidLangsMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<PostApiV1ExamExamidLangsMutationRequest>> & {
      client?: Client;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? postApiV1ExamExamidLangsMutationKey();

  const baseOptions = postApiV1ExamExamidLangsMutationOptions(
    config,
  ) as UseMutationOptions<
    PostApiV1ExamExamidLangsMutationResponse,
    ResponseErrorConfig<
      | PostApiV1ExamExamidLangs401
      | PostApiV1ExamExamidLangs404
      | PostApiV1ExamExamidLangs500
    >,
    {
      examId: PostApiV1ExamExamidLangsPathParams["examId"];
      data?: PostApiV1ExamExamidLangsMutationRequest;
    },
    TContext
  >;

  return useMutation<
    PostApiV1ExamExamidLangsMutationResponse,
    ResponseErrorConfig<
      | PostApiV1ExamExamidLangs401
      | PostApiV1ExamExamidLangs404
      | PostApiV1ExamExamidLangs500
    >,
    {
      examId: PostApiV1ExamExamidLangsPathParams["examId"];
      data?: PostApiV1ExamExamidLangsMutationRequest;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiV1ExamExamidLangsMutationResponse,
    ResponseErrorConfig<
      | PostApiV1ExamExamidLangs401
      | PostApiV1ExamExamidLangs404
      | PostApiV1ExamExamidLangs500
    >,
    {
      examId: PostApiV1ExamExamidLangsPathParams["examId"];
      data?: PostApiV1ExamExamidLangsMutationRequest;
    },
    TContext
  >;
}
